import React, { Fragment } from "react";
import PropTypes from "prop-types";

import useGet from "../../hooks/useGet";
import { EligibilityProvider } from "../../contexts/EligibilityContext";

import DiseaseFundLoading from "./DiseaseFundLoading";
import DiseaseFundError from "./DiseaseFundError";
import DiseaseFundMaintenance from "./DiseaseFundMaintenance";
import DiseaseFundBanner from "./DiseaseFundBanner";
import DiseaseFundInfo from "./DiseaseFundInfo";
import DiseaseFundMeds from "./DiseaseFundMeds";

const apiUrl = "/wp-json/salesforce/v1/funds";

const DiseaseFundDetail = ({
  title,
  groupId,
  maintenance,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
  jumpLink,
  eligibilityCriteria,
  assistanceAmount,
  additionalAssistanceAmountInformation,
}) => {
  const [loading, response, error] = useGet(
    `${apiUrl}/${groupId}?criteria=true&medications=true`
  );

  return (
    <Fragment>
      {response && !loading && !maintenance && (
        <EligibilityProvider>
          <DiseaseFundBanner
            title={title}
            data={response.data.funds[0]}
            jumpLink={jumpLink}
          />

          {!maintenance && (
            <Fragment>
              <DiseaseFundInfo
                title={title}
                data={response.data.funds[0]}
                eligibilityCriteria={eligibilityCriteria}
                assistanceAmount={assistanceAmount}
                additionalAssistanceAmountInformation={additionalAssistanceAmountInformation}
              />
              <DiseaseFundMeds
                medications={response.data.funds[0].medications}
                groupId={groupId}
              />
            </Fragment>
          )}
        </EligibilityProvider>
      )}

      {loading && !maintenance && <DiseaseFundLoading title={title} />}

      {error && !maintenance && <DiseaseFundError title={title} />}

      {maintenance && (
        <DiseaseFundMaintenance
          title={title}
          maintenanceMessageLine1={maintenanceMessageLine1}
          maintenanceMessageLine2={maintenanceMessageLine2}
        />
      )}
    </Fragment>
  );
};

DiseaseFundDetail.propTypes = {
  title: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  eligibilityCriteria: PropTypes.string,
  assistanceAmount: PropTypes.string,
  additionalAssistanceAmountInformation: PropTypes.string
};

export default DiseaseFundDetail;
